/** Milestone-based payment schedule used on purchase orders. */
export const PURCHASE_ORDER_PAYMENT_TERM_MILESTONE =
  'Advance Payment 35%, Draft Documentation Completion 30%, Internal Audit/API filing 15%, Final Payment 20%';

export const PURCHASE_ORDER_PAYMENT_TERMS_OPTIONS: { value: string; label: string }[] = [
  { value: 'COD', label: 'COD' },
  { value: 'Net 15', label: 'Net 15' },
  { value: 'Net 30', label: 'Net 30' },
  { value: 'Net 45', label: 'Net 45' },
  { value: 'Net 60', label: 'Net 60' },
  {
    value: PURCHASE_ORDER_PAYMENT_TERM_MILESTONE,
    label: PURCHASE_ORDER_PAYMENT_TERM_MILESTONE,
  },
];
